"use client"

import { useState } from "react"
import "./PolicyPages.css"

export default function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  })

  const [submitted, setSubmitted] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    // Here you would typically send the form data to your backend
    console.log("Form submitted:", formData)
    setSubmitted(true)

    // Reset form after submission
    setFormData({
      name: "",
      email: "",
      subject: "",
      message: "",
    })

    // Reset submission status after 5 seconds
    setTimeout(() => {
      setSubmitted(false)
    }, 5000)
  }

  return (
    <div className="policy-container">
      <div className="policy-content">
        <h1>Contact Us</h1>

        <section className="policy-section">
          <h2>Get in Touch</h2>
          <p>
            We're here to help! If you have any questions, concerns, or feedback, please don't hesitate to reach out to
            us using the contact information below or by filling out the contact form.
          </p>
        </section>

        <section className="policy-section contact-info">
          <h2>Contact Information</h2>
          <div className="contact-details">
            <div className="contact-item">
              <h3>Customer Support</h3>
              <p>Email: support@example.com</p>
              <p>Phone: (123) 456-7890</p>
              <p>Hours: Monday-Friday, 9:00 AM - 5:00 PM</p>
            </div>

            <div className="contact-item">
              <h3>Business Inquiries</h3>
              <p>Email: business@example.com</p>
              <p>Phone: (123) 456-7891</p>
            </div>

            <div className="contact-item">
              <h3>Physical Address</h3>
              <p>123 Bakery Street</p>
              <p>Suite 456</p>
              <p>Sweetville, CA 98765</p>
              <p>United States</p>
            </div>
          </div>
        </section>

        <section className="policy-section">
          <h2>Contact Form</h2>
          {submitted ? (
            <div className="success-message">
              <p>Thank you for your message! We'll get back to you as soon as possible.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="5"
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-button">
                Send Message
              </button>
            </form>
          )}
        </section>

        <section className="policy-section">
          <h2>Response Time</h2>
          <p>
            We strive to respond to all inquiries within 24-48 hours during business days. For urgent matters, please
            contact us by phone.
          </p>
        </section>
      </div>
    </div>
  )
}

